import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ComercialModel } from '../../models/comercial/comercial.model';
import { ComercialRepository } from '../../repositories/comercial.repository';

export class GetComercialAllUseCase
  implements
    UseCase<
      {
        idEstadoProspecto: string;
        idUsuarioCreacion: string;
      },
      ComercialModel
    >
{
  constructor(private comercialRepository: ComercialRepository) {}
  execute(params: {
    idEstadoProspecto: string;
    idUsuarioCreacion: string;
  }): Observable<ComercialModel> {
    return this.comercialRepository.getComercialAll(params);
  }
}
